"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Clear_1 = require("@mui/icons-material/Clear");
const merge_1 = require("merge");
const SectionTitle_style_1 = require("./SectionTitle.style");
const SectionTitle = (_a) => {
    var { title = 'Title', content = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Error  suscipit quasi enim ', onCloseHandle } = _a, props = __rest(_a, ["title", "content", "onCloseHandle"]);
    const { container, titleCardStyle, titleTypographyStyle, contentTypographyStyle } = (0, SectionTitle_style_1.default)();
    const { containerOverrides, titleCardOverrides, titleTypographyOverrides, contentTypographyOverrides } = props;
    return ((0, jsx_runtime_1.jsx)(material_1.Card, { "data-testid": "card", sx: (0, merge_1.merge)(true, container, containerOverrides), children: (0, jsx_runtime_1.jsxs)("div", { style: (0, merge_1.merge)(true, titleCardStyle, titleCardOverrides), children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { "data-testid": "title", sx: (0, merge_1.merge)(true, titleTypographyStyle, titleTypographyOverrides), children: [title, (0, jsx_runtime_1.jsx)(Clear_1.default, { "data-testid": "clear", className: "icon", onClick: onCloseHandle })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "content", sx: (0, merge_1.merge)(true, contentTypographyStyle, contentTypographyOverrides), variant: "body2", children: content })] }) }));
};
exports.default = SectionTitle;
